import {PartnerBrandRewardsDataApiDto, UpdatePartnerBrandRewardsDataApiDto} from "../../api/model/rest";
import JsonConverter from "../../api/helper/JsonConverter";
import moment = require("moment");

export default class PartnerBrandRewardsData {
	constructor(
		public readonly signUpDate: moment.Moment,
		public readonly status: string,
		public readonly submittedPoints: number,
		public readonly earnedPoints: number,
		public readonly usedPoints: number,
		public readonly availablePoints: number,
	) {}

	static fromJson(json: PartnerBrandRewardsDataApiDto): PartnerBrandRewardsData {
		const signUpDate = json.signUpDate ? moment(json.signUpDate) : null;
		return new PartnerBrandRewardsData(signUpDate, json.status, json.submittedPoints, json.earnedPoints, json.usedPoints,
			json.availablePoints);
	}

	toJson(): UpdatePartnerBrandRewardsDataApiDto {
		const json: UpdatePartnerBrandRewardsDataApiDto = {
			status: this.status,
			signUpDate: this.signUpDate.format(),
		};
		return JsonConverter.removeEmptyFields(json);
	}
}

export enum RewardsStatus {
	MEMBER = "Member",
	SILVER = "Silver",
	GOLD = "Gold",
	PLATINUM = "Platinum",
	PLATINUM_ONE = "Platinum one"
}